var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vs-select',{attrs:{"placeholder":"Project"},model:{value:(_vm.project),callback:function ($$v) {_vm.project=$$v},expression:"project"}},_vm._l((_vm.projects),function(project,index){return _c('vs-option',{key:index,attrs:{"value":project}},[_vm._v(" "+_vm._s(project)+" ")])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }